import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form} from "reactstrap";

//redux
import {useSelector, useDispatch} from "react-redux";

import {Link, useNavigate} from "react-router-dom";
import withRouter from "../../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import {useFormik} from "formik";

// action
import {userForgetPassword} from "../../../slices/thunks";

// import images
// import profile from "../../assets/images/bg.png";
import logoLight from "../../../assets/images/logo-light.png";
import ParticlesAuth from "./ParticlesAuth";
import {createSelector} from "reselect";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import AuthSlider from "./authCarousel";
import Select from "react-select";
import axios from 'axios';
const ForgetPasswordPage = props => {

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [users, setUsers] = useState({
        login: '',
    });

    const handleChange = (event) => {
        const {name, value} = event.target;
        setUsers(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);

        axios.post(process.env.REACT_APP_URL_API + 'password/forgot', users)
            .then(res => {
                setErrorMessage('');
                setSuccessMessage('Link de redefinição de senha enviado para seu e-mail.');
            })
            .catch(error => {
                setSuccessMessage('');
                setErrorMessage('Ocorreu um erro ao tentar enviar o link de redefinição. Por favor, tente novamente.');
            })
            .finally(() => {
                setLoading(false); // <- Aqui finaliza o loading
            });
    };


    document.title = "Login | Plantão Rápido";

    return (
        <React.Fragment>
            <div
                className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider/>
                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div className="login-right">
                                                    <div className="login-right-wrap">
                                                        <h5>Esqueceu Sua Senha?</h5>
                                                        <p className="account-subtitle">
                                                            Digite seu e-mail para obter um link de redefinição de senha
                                                        </p>
                                                        {/* Form */}
                                                        <form onSubmit={handleSubmit}>
                                                            <div className="form-group">
                                                                <input
                                                                    type="login"
                                                                    name="login"
                                                                    value={users.login}
                                                                    onChange={handleChange}
                                                                    placeholder="Digite seu e-mail"
                                                                    className="form-control floating"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group mb-0">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary w-100 btn-lg login-btn mt-2"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? (
                                                                        <span><i
                                                                            className="spinner-border spinner-border-sm me-2"/>Enviando...</span>
                                                                    ) : (
                                                                        'Redefinir Senha'
                                                                    )}
                                                                </button>
                                                            </div>

                                                        </form>
                                                        {/* /Form */}
                                                        {errorMessage && <div
                                                            className="alert alert-danger mt-3">{errorMessage}</div>}
                                                        {successMessage && <div
                                                            className="alert alert-success mt-3">{successMessage}</div>}
                                                        <div className="text-center dont-have">
                                                            Lembra da sua senha? <Link to="/login">Login</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>

                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} <a className="text-reset text-decoration-none" target="_blank" href="https://medr.com.br/">MEDR</a>.
                                        Todos Direitos
                                        Reservados</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>
    );
};


ForgetPasswordPage.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
